import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Divider,
  TextAction,
  FormField,
  TextInput,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../../../../types/forms-library.types';
import { RemoveServiceWarningModal } from '../../../layout/removeServiceWarningModal';
import { RemoveServiceSuccessModal } from '../../../layout/removeServiceSuccessModal';
import { ServiceDetailsInformation } from './service-details-information.component';
import {
  isEmpty,
  isNotEmpty,
  isValidDate,
  updateFormData,
} from '../../../helpers';

export function ServiceInformation(props: any) {
  const {
    errorHandling,
    nextButtonClicked,
    isValidateForm,
    footerToBottom,
    setIsAttaachmentLoading,
  } = props;

  const addIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.ADD_ICON);

  const [form, setForm] = useState({
    services: [
      {
        serviceType: '',
        dateOfService: '',
        expenseIncurred: '',
        expenseValue: 0,
        attachments: [],
      },
    ],
    errors: [
      {
        serviceType: false,
        dateOfService: '',
        expenseIncurred: false,
        attachments: false,
      },
    ],
    totalExpenses: '$0.00',
  });

  const [serviceObj] = useState({
    serviceType: '',
    dateOfService: '',
    expenseIncurred: '',
    expenseValue: 0,
    attachments: [],
  });

  const [error] = useState({
    serviceType: false,
    dateOfService: '',
    expenseIncurred: false,
    attachments: false,
  });
  const [isRemoveServiceSuccessModal, setIsRemoveServiceSuccessModal] =
    useState<boolean>(false);

  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);

  const formFieldArr = form.services.map(
    (ser: any) =>
      isEmpty(ser.serviceType) ||
      isEmpty(ser.dateOfService) ||
      !isValidDate(ser.dateOfService) ||
      isEmpty(ser.expenseIncurred) ||
      ser.attachments.length === 0,
  );
  const formField = formFieldArr.reduce(
    (field1: boolean, field2: boolean) => field1 || field2,
  );

  const isValidArr = form.services.map(
    (ser: any) =>
      isNotEmpty(ser.serviceType) &&
      isNotEmpty(ser.dateOfService) &&
      isValidDate(ser.dateOfService) &&
      isNotEmpty(ser.expenseIncurred) &&
      ser.attachments.length !== 0,
  );
  const isValid = isValidArr.reduce(
    (field1: boolean, field2: boolean) => field1 && field2,
  );

  useEffect(() => {
    if (formField) {
      errorHandling(false);
    } else {
      errorHandling(true);
    }
  }, [formField, errorHandling]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        const errorCopy = form.errors.map((err: any, index: any) => ({
          serviceType: isEmpty(form.services[index].serviceType),
          dateOfService:
            (isEmpty(form.services[index].dateOfService) && 'error1') ||
            (!isValidDate(form.services[index].dateOfService) && 'error2'),
          expenseIncurred: isEmpty(form.services[index].expenseIncurred),
          attachments: form.services[index].attachments.length === 0,
        }));
        setForm((prevState: any) => ({
          ...prevState,
          errors: errorCopy,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextButtonClicked, isValid, form.services]);

  const updateErrorState = (errorData: any, index: any) => {
    const errorCopy = [...form.errors];
    errorCopy[index] = errorData;
    setForm((prevState: any) => ({
      ...prevState,
      errors: errorCopy,
    }));
    isValidateForm(false);
  };

  const onUpdateField = (serviceData: any, index: any) => {
    const serviceArrCopy: any[] = [...form.services];
    serviceArrCopy[index] = serviceData;
    setForm((prevState: any) => ({
      ...prevState,
      services: serviceArrCopy,
    }));
  };

  const addService = () => {
    const serviceArrCopy: any[] = [...form.services];
    serviceArrCopy.push(serviceObj);

    const errorCopy = [...form.errors];
    errorCopy.push(error);

    setForm((prevState: any) => ({
      ...prevState,
      services: serviceArrCopy,
      errors: errorCopy,
    }));

    isValidateForm(false);
  };

  const updateTotalExpenses = () => {
    let newTotal = 0;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < form.services.length; i++) {
      newTotal += form.services[i].expenseValue;
    }

    const currency = Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(newTotal);

    setForm((prevState: any) => ({
      ...prevState,
      totalExpenses: currency,
    }));
  };

  const removeService = (indexToRemove: any) => {
    const serviceArrCopy = [...form.services];
    serviceArrCopy.splice(indexToRemove, 1);

    const errorCopy = [...form.errors];
    errorCopy.splice(indexToRemove, 1);

    let newTotal = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < serviceArrCopy.length; i++) {
      newTotal += serviceArrCopy[i].expenseValue;
    }
    const currency = Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(newTotal);

    setForm((prevState: any) => ({
      ...prevState,
      services: serviceArrCopy,
      errors: errorCopy,
      totalExpenses: currency,
    }));

    setIsRemoveServiceSuccessModal(true);
  };

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm((prevState: any) => ({
        ...prevState,
        services: pInfo.services || form.services,
        totalExpenses: pInfo.totalExpenses || '$0.00',
      }));
      if (pInfo.errors) {
        const errorInfo = pInfo.errors.map(() => ({
          serviceType: false,
          dateOfService: '',
          expenseIncurred: false,
          attachments: false,
        }));
        setForm((prevState: any) => ({
          ...prevState,
          errors: errorInfo,
        }));
      } else {
        setForm((prevState: any) => ({
          ...prevState,
          errors: form.errors,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  return (
    <StackLayout
      css={
        {
          backgroundColor: 'White',
          maxWidth: '800px',
        } as GDSStyleObject
      }
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        {isRemoveServiceSuccessModal && (
          <RemoveServiceSuccessModal
            onClose={() => setIsRemoveServiceSuccessModal(false)}
            openSuccessModal={isRemoveServiceSuccessModal}
          />
        )}
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$none $two',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="1"
            size={{
              '@initial': 'xxl',
              '@mobile': 'xl',
              '@mobileLandscape': 'xl',
              '@tablet': 'xl',
              '@laptop': 'xxl',
              '@desktop': 'xxl',
            }}
          >
            Direct Reimbursement Claim Form
          </HeadingText>
        </Box>

        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              padding: '$one $two',
              width: '100%',
            } as GDSStyleObject
          }
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
              } as GDSStyleObject
            }
          >
            <HeadingText
              level="3"
              size={{
                '@initial': 'xl',
                '@mobile': 'lg',
                '@mobileLandscape': 'lg',
                '@tablet': 'xl',
                '@laptop': 'xl',
                '@desktop': 'xl',
              }}
            >
              Step 3: Service Information
            </HeadingText>
          </Box>
        </Box>

        {form.services.map((ser: any, index: any) => (
          <>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$none $two',
                } as GDSStyleObject
              }
            >
              <ParagraphText
                css={
                  {
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '32px',
                  } as GDSStyleObject
                }
              >
                Service {index + 1}
              </ParagraphText>
            </Box>
            <Box
              css={
                {
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '$none $two',
                } as GDSStyleObject
              }
            >
              <ServiceDetailsInformation
                serviceDetails={ser}
                errorDetails={form.errors[index]}
                index={index}
                updateService={onUpdateField}
                updateError={updateErrorState}
                updateTotalExpenses={updateTotalExpenses}
                setIsAttaachmentLoading={setIsAttaachmentLoading}
              />
              {form.services.length > 1 && (
                <Box
                  css={
                    {
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                    } as GDSStyleObject
                  }
                >
                  <RemoveServiceWarningModal
                    onClose={() => removeService(index)}
                  />
                </Box>
              )}
              <Divider />
            </Box>
          </>
        ))}

        {form.services.length < 10 && (
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                padding: '$one $two',
              } as GDSStyleObject
            }
          >
            <TextAction
              icon={addIcon as string}
              size={{
                '@initial': 'large',
                '@mobile': 'medium',
                '@tablet': 'large',
              }}
              as="button"
              onClick={addService}
            >
              Add Another Service
            </TextAction>
          </Box>
        )}
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '$one $two',
              maxWidth: '700px',
            } as GDSStyleObject
          }
        >
          <FormField id="totalExpenses" label="Total Expenses">
            <TextInput disabled value={form.totalExpenses} />
          </FormField>
        </Box>
      </Box>
    </StackLayout>
  );
}
